import { useMutation } from '@tanstack/react-query';
import { usePostHog } from 'posthog-js/react';
import { resetRefreshState } from '@/Config/api/httpClient.config';
import { clearToken } from '@/Config/auth/authStore';

export const useLogout = () => {
  const posthog = usePostHog();

  const mutation = useMutation({
    mutationKey: ['accounts/logout'],
    onSuccess: () => {
      // Tear down auth state BEFORE anything that can throw (posthog.reset) so
      // the in-memory token and any in-flight refresh never outlive the session
      // even if the subsequent full-page reload is delayed or interrupted.
      clearToken();
      resetRefreshState();
      posthog.reset();
      window.location.pathname = '/';
    },
  });

  const handleLogout = () => {
    mutation.mutate();
  };

  return { handleLogout };
};
